export default __webpack_public_path__ + "static/media/D9C99ED9-00.8bf8b7b2.png";